import { Plans } from './Plans';

export function Services() {
  return <Plans mode="services" />;
}
